import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFrameScaling,
} from "../../../../../shared/utils/door";

interface BeamProps {
  id: string | null;
  doorNodes: any;
  materials: DoorGlassMaterial;
  width: number;
  height: number;
}

const Beam: React.FC<BeamProps> = ({
  id,
  doorNodes,
  materials,
  width,
  height,
}: BeamProps) => {
  const { eigenwijs, getConfigurationColor } = useConfigurationOptionsContext();
  const scaling = getFrameScaling(width, height);
  const material = materials[getConfigurationColor()];

  return (
    <group>
      <mesh
        geometry={doorNodes["beam"].geometry}
        material={material}
        position={[0, height, 0]}
        scale={[scaling.horizontal.x, 1, 1]}
      >
        {id && id === eigenwijs?.selectedBeam && (
          <meshStandardMaterial
            color={material.color}
            opacity={0.6}
            transparent={true}
          />
        )}
      </mesh>
    </group>
  );
};

export default Beam;
